import { useEffect, useRef, useState } from "react";
import {
  getRoles,
  editRole,
  addRole,
  removeRole,
} from "../state-management/actions/role-actions";
import Container from "../components/basicComponents/container";
import * as Icons from "../assets/SVGs/index";
import Grid from "../components/grid";
import { useDispatch } from "react-redux";
import { generateColumns } from "../utils/generate-columns-permission";
import { SidebarData } from "../components/sidebar/sidebar-data";
import TextInput from "../components/basicComponents/text-input";
import Button from "../components/basicComponents/button";
import { setRowStatus } from "../state-management/actions/global-state-actions";

export default function AccessLevel() {
  const dispatch = useDispatch();
  const [newRoleName, setNewRoleName] = useState("");
  const [rolesData, setRolesData] = useState<any>([]);
  const [updateFlag, setUpdateFlag] = useState(false);
  const permissionRef = useRef<string[]>([]);
  const roleRef = useRef<string>("");
  const editedRoleNameRef = useRef<string>("");
  const columns = generateColumns(SidebarData);
  const publicPaths =  ["/profile", "/forgot-password", "/notification"]

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRoles()(dispatch);
        setRolesData(response.data);
        setNewRoleName(" ");
      } catch (error) {
        console.log(error);
      }
    };
    dispatch(setRowStatus("clear id", false));
    fetchData();
  }, [updateFlag]);

  const colField = columns.map((item: any) => item.field);
  console.log(colField);
  const handleSubmit = async () => {
    const newRole = {
      name: newRoleName,
      permissions:publicPaths,
    };
    try {
      await addRole(newRole)(dispatch);
      setUpdateFlag((prev: any) => !prev);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = async (id: string) => {
    const editingData = rolesData.find((item: any) => item._id === id);

    try {
      if (
        Array.isArray(permissionRef.current) &&
        permissionRef.current.length
      ) {
        await editRole(id, {
          name: editedRoleNameRef.current,
          permissions: [...permissionRef.current,...publicPaths],
        })(dispatch);

        editedRoleNameRef.current = " ";
        permissionRef.current = [];
        setUpdateFlag((prev: any) => !prev);
      } else {
        permissionRef.current = editingData.permissions;

        await editRole(id, {
          name: editedRoleNameRef.current,
          permissions: [...permissionRef.current,...publicPaths]
        })(dispatch);

        editedRoleNameRef.current = " ";
        permissionRef.current = [];
        setUpdateFlag((prev: any) => !prev);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSetdata = async (clear: boolean, id: string) => {
    editedRoleNameRef.current = rolesData.find(
      (item: any) => item._id === id
    ).name;
    if (clear) editedRoleNameRef.current = " ";
  };

  const handleDelete = async (id: string) => {
    try {
      await removeRole(id)(dispatch);
      setUpdateFlag((prev: any) => !prev);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCellChange = (params: any) => {
    const pagePath = params.colDef.field;
    roleRef.current = params.data._id;

    const rolePermissions = rolesData.find(
      (dep: any) => roleRef.current === dep._id
    )?.permissions;

    permissionRef.current = rolePermissions ? [...rolePermissions] : [];

    if (!permissionRef.current.includes(pagePath)) {
      permissionRef.current = [...permissionRef.current, pagePath];
    } else {
      permissionRef.current = permissionRef.current.filter(
        (id) => id !== pagePath
      );
    }

    // حذف موارد اضافی
    permissionRef.current = permissionRef.current.filter((item) =>
      colField.includes(item)
    );

    params.data.permissions = [...permissionRef.current];

    setRolesData((prevRolesData: any) =>
      prevRolesData.map((role: any) =>
        role._id === roleRef.current
          ? { ...role, permissions: [...permissionRef.current] }
          : role
      )
    );
  };

  const handleRoleNameChange = (params: any) => {
    editedRoleNameRef.current = rolesData.find(
      (item: any) => item._id === params.data._id
    ).name;
  };

  const enhancedColumns = [
    {
      headerName: "نام و نام خانوادگی",
      field: "name",
      editable: true,
      cellEditor: "agTextCellEditor",
      onCellValueChanged: handleRoleNameChange,
      pinned: "right",
    },
    ...columns.map((column: any) => ({
      ...column,
      valueGetter: (params: any) => {
        const userPermissions = Array.isArray(params.data.permissions)
          ? params.data.permissions
          : [];
        return userPermissions.includes(column.field);
      },
      cellRenderer: "agCheckboxCellRenderer",
    })),
  ];

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <Container header="مجوز نقش ها">
        <div className="flex gap-x-4 w-full">
          <TextInput
            label="نقش"
            name="roleName"
            placeholder="تعریف نقش جدید"
            RightIcon={<Icons.UserRoleIcon />}
            textAlign="right"
            value={newRoleName}
            onChange={(e) => setNewRoleName(e.target.value)}
          />
          <Button
            variant={"success"}
            title={"ثبت"}
            paddingx="20px"
            paddingy="6px"
            onClick={handleSubmit}
          />
        </div>
        <Grid
          height={600}
          columns={enhancedColumns}
          userData={rolesData}
          pageSize={50}
          pagination={true}
          editBtn={true}
          deleteBtn={true}
          editable={true}
          btnHeader="عملیات"
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleSetData={handleSetdata}
          onCellValueChanged={handleCellChange}
        />
      </Container>
    </div>
  );
}
